import { Job } from 'graphql-common';
import _get from 'lodash/get';
import toast from '@lib/components/Toast/Toast';

const fetchJobs = async ({
  jobIds,
  fetchJobStatus,
  onUpdateJobs,
}: {
  jobIds: string[];
  fetchJobStatus: any;
  onUpdateJobs: (jobs: Job[]) => void;
}) => {
  if (jobIds.length) {
    fetchJobStatus({
      variables: { jids: jobIds },
      onCompleted: (response: any) => {
        const updatedJobs = _get(response, 'data', []) as Job[];
        onUpdateJobs(updatedJobs);
      },
      onError: (error: Error) => {
        console.error(error);
        toast({ content: error.message || 'Oops! Something went wrong' });
      },
    });
  }
};

export default fetchJobs;
